import styled from "@emotion/styled"
import { PBanner } from "@porsche-design-system/components-react"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import type { MessageDescriptor } from "react-intl"
import { FormattedMessage } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { ErrorGroup } from "./ErrorGroup"
import type { FormValidationBannerItem } from "./FormValidationBannerItem"

const MAX_DISPLAY_ERROR = 3

export interface FormValidationBannerGroup {
	items: FormValidationBannerItem[]
	message: MessageDescriptor
}

export interface FormValidationBannerProps {
	groups: FormValidationBannerGroup[]
	onDismiss: () => void
	requestError?: { message: string }
}

export const FormValidationBanner = ({ groups, onDismiss, requestError }: FormValidationBannerProps) => {
	const visibleGroups = groups.filter((group) => group.items.length > 0)

	return visibleGroups.length > 0 || requestError ? (
		<PBanner data-testid="form-validation-banner" state="error" open onDismiss={onDismiss}>
			<span slot="heading">
				<FormattedMessage {...commonMessages.error} />
			</span>
			<Column>
				{requestError?.message}
				{visibleGroups.map((group, index) => (
					<ErrorGroup
						key={`${group.message.id}-${index}`}
						errors={group.items}
						maxDisplayError={MAX_DISPLAY_ERROR}
						message={group.message}
					/>
				))}
			</Column>
		</PBanner>
	) : null
}

const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd};
`
